export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de productores"])},
          "crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo(s)"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar productor"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el productor?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "new_crop_field_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir campo"])},
          "destroy_crop_field_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_crop_field_button_title": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Eliminar campo ", _interpolate(_named("crop_field"))])},
          "destroy_crop_field_button_message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["¿Está seguro de eliminar el campo ", _interpolate(_named("crop_field")), "?"])},
          "destroy_crop_field_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])}
        }
      },
      "en": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producer"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go back to list of producers"])},
          "crop_fields": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Farm(s)"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Edit"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destroy"])}
        }
      }
    }
  })
}